module.exports = __webpack_public_path__ + "static/bindWechat.03834b55.png";